module.exports = __webpack_public_path__ + "static/media/icon_failed-runs-issue.85ad6c51.svg";